export default "__VITE_ASSET__d821ae4b__"